import React from 'react';
import styled from 'styled-components';
import Character from 'components/CharacterWeb';
import Title from 'components/Title';
import { TextStyle } from 'components/Text';

export const ImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 0 5vw;
  margin-bottom: ${(props) => props.marginBottom}vw;
`;
export const CharacterContainer = styled.div`
  position: relative;
`;
export const StyledText = styled(TextStyle)`
  position: absolute;
  bottom: -1vw;
  width: 100%;
  text-align: center;
`;

const getRowCount = (count) => {
  if (count > 10) {
    return 3;
  }
  return 2;
};
const getColumnCount = (count) => {
  if (count > 12) {
    return 5;
  }
  if (count > 10) {
    return 4;
  }
  if (count > 8) {
    return 5;
  }
  if (count > 6) {
    return 4;
  }
  return 3;
};
const getScale = (count) => {
  if (count > 10) {
    return 1;
  }
  if (count > 8) {
    return 1.2;
  }
  return 1.3;
};

export const CharacterListTitle = styled(Title)`
  margin: 3vw 3vw 0 3vw;
  text-align: center;
`;

export const CharacterList = ({ players, showName }) => {
  players.sort((a, b) => a.role.localeCompare(b.role));
  const rowCount = getRowCount(players.length);
  const columnCount = getColumnCount(players.length);
  const scale = getScale(players.length);

  const Rows = Array.from({ length: rowCount }, (_, i) => {
    const startIndex = i * columnCount;
    const endIndex = startIndex + columnCount;
    const currentPlayers = players.slice(startIndex, endIndex);

    return (
      <ImageContainer marginBottom={rowCount === 3 ? 1 : 5} key={i}>
        {currentPlayers.map((player) => {
          return (
            <CharacterContainer key={player.id}>
              <Character
                role={player.image}
                scale={scale}
                isExpired={player.expired}
              />
              {showName && <StyledText white>{player.userName}</StyledText>}
            </CharacterContainer>
          );
        })}
      </ImageContainer>
    );
  });
  return Rows;
};
